(() => {
  'use strict';

  const productPbSelector = '.main-product .shopify-app-block > .ak-pbpf--product[data-ak-pbpf-root]';
  const cartPbSelector = '.main-cart .cart__ctas > .ak-pbpf__launch--cart';
  const layoutScript = document.querySelector('script[data-tbi-layout]');
  const logoUrl = layoutScript?.dataset.tbiLogoUrl || '';
  const observedShadowRoots = new WeakSet();
  let updateQueued = false;

  function customizeTbiButton(button) {
    if (!button) return true;

    button.setAttribute('aria-label', 'Купи на изплащане с tbi bank');

    const shadowRoot = button.querySelector('.tbiCiShadowHost')?.shadowRoot;
    if (!shadowRoot) return false;

    const label = shadowRoot.querySelector('.tbiCiLabel');
    const logo = shadowRoot.querySelector('.tbiLogo');
    const subtext = shadowRoot.querySelector('.tbiCiSubtext');

    if (label && label.textContent !== 'Купи на изплащане с') {
      label.textContent = 'Купи на изплащане с';
    }
    if (logo && logoUrl) {
      if (logo.src !== logoUrl) logo.src = logoUrl;
      if (logo.alt !== 'tbi bank') logo.alt = 'tbi bank';
    }
    if (subtext && !subtext.hidden) subtext.hidden = true;

    if (!shadowRoot.querySelector('style[data-akimstar-tbi-style]')) {
      const style = document.createElement('style');
      style.dataset.akimstarTbiStyle = '';
      style.textContent = `
        .tbiCiContent { row-gap: 0 !important; }
        .tbiCiTopRow { gap: 8px !important; }
        .tbiCiLabel { font-size: 15px !important; font-weight: 700 !important; }
        .tbiCiLogo, .tbiLogo {
          width: 92px !important;
          max-width: 92px !important;
          height: 40px !important;
          object-fit: contain !important;
        }
        .tbiCiSubtext { display: none !important; }
      `;
      shadowRoot.appendChild(style);
    }

    if (!observedShadowRoots.has(shadowRoot)) {
      observedShadowRoots.add(shadowRoot);
      new MutationObserver(() => {
        window.requestAnimationFrame(() => customizeTbiButton(button));
      }).observe(shadowRoot, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    return Boolean(label && logo);
  }

  function suppressMiniCartButton() {
    const miniCartButton = document.querySelector('#tbiMiniCartButton');
    if (!miniCartButton) return;

    miniCartButton.hidden = true;
    miniCartButton.setAttribute('aria-hidden', 'true');
    miniCartButton.setAttribute('tabindex', '-1');
  }

  function createPlaceholder(id) {
    const placeholder = document.createElement('span');
    const label = document.createElement('span');
    const logo = document.createElement('img');

    placeholder.id = id;
    placeholder.className = 'tbi-bank-placeholder';
    placeholder.setAttribute('aria-hidden', 'true');

    label.className = 'tbi-bank-placeholder__label';
    label.textContent = 'Купи на изплащане с';

    logo.className = 'tbi-bank-placeholder__logo';
    logo.src = logoUrl;
    logo.alt = '';
    logo.width = 92;
    logo.height = 40;

    placeholder.append(label, logo);
    return placeholder;
  }

  function isButtonReady(button, customized) {
    return Boolean(
      button &&
        customized &&
        button.dataset.tbiMounted === '1' &&
        button.dataset.tbiClickBound === '1' &&
        button.getAttribute('aria-disabled') !== 'true'
    );
  }

  function positionTbiButtons() {
    const productButton = document.querySelector('#tbiButton');
    const productPb = document.querySelector(productPbSelector);
    const productCustomized = customizeTbiButton(productButton);
    const productReady = isButtonReady(productButton, productCustomized);

    if (productPb) {
      const productPbBlock = productPb.closest('.shopify-app-block');

      if (productPbBlock) {
        productPbBlock.classList.add('tbi-pbpf-product-pair');
        const productPlaceholder = document.querySelector('#tbiProductPlaceholder');

        if (productReady) {
          productButton.classList.remove('tbi-bank-awaiting-ready');
          productPlaceholder?.remove();
          if (productButton.parentElement !== productPbBlock || productButton.previousElementSibling !== productPb) {
            productPb.insertAdjacentElement('afterend', productButton);
          }
        } else {
          productButton?.classList.add('tbi-bank-awaiting-ready');
          if (!productPlaceholder) {
            productPb.insertAdjacentElement('afterend', createPlaceholder('tbiProductPlaceholder'));
          }
        }
      }
    }

    const cartButton = document.querySelector('#tbiCartButton');
    const cartPb = document.querySelector(cartPbSelector);
    const cartCustomized = customizeTbiButton(cartButton);
    const cartReady = isButtonReady(cartButton, cartCustomized);

    if (cartPb) {
      const cartPlaceholder = document.querySelector('#tbiCartPlaceholder');

      if (cartReady) {
        cartButton.classList.remove('tbi-bank-awaiting-ready');
        cartPlaceholder?.remove();
        if (cartButton.previousElementSibling !== cartPb) {
          cartPb.insertAdjacentElement('afterend', cartButton);
        }
      } else {
        cartButton?.classList.add('tbi-bank-awaiting-ready');
        if (!cartPlaceholder) {
          cartPb.insertAdjacentElement('afterend', createPlaceholder('tbiCartPlaceholder'));
        }
      }
    }

    suppressMiniCartButton();

    if ((productPb && !productReady) || (cartPb && !cartReady)) {
      window.setTimeout(queuePositionUpdate, 250);
    }
  }

  function queuePositionUpdate() {
    if (updateQueued) return;

    updateQueued = true;
    window.requestAnimationFrame(() => {
      updateQueued = false;
      positionTbiButtons();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queuePositionUpdate, { once: true });
  } else {
    queuePositionUpdate();
  }

  new MutationObserver(queuePositionUpdate).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
